import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__sortable-table';
export class SortableTable {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.each((index, element) => {
            this.highlightSortedColumn($(element));
            this.addSortedIconsToHeader($(element));
        });
    }
    static highlightSortedColumn($element) {
        const $sortedColumn = $element.find('th.sorted');
        const sortedColumnIndex = $sortedColumn.index();
        const $rows = $element.find('tbody tr');
        $rows.each((index, element) => {
            const tdElement = $(element).find('td').get(sortedColumnIndex);
            $(tdElement).addClass('sorted-cell');
        });
    }
    static addSortedIconsToHeader($element) {
        const $sortedColumn = $element.find('th.sorted');
        const columnSortLink = $sortedColumn.find('a');
        if ($sortedColumn.hasClass('descending')) {
            const $descendingIcon = $('<i class="icon sort amount down ml-2"></i>');
            columnSortLink.append($descendingIcon);
        }
        else if ($sortedColumn.hasClass('ascending')) {
            const $ascendingIcon = $('<i class="icon sort amount up ml-2"></i>');
            columnSortLink.append($ascendingIcon);
        }
    }
}
